import React from "react"
import "./Spinner.scss"

export const Spinner = ({size = "large"}) => {
  return (
    <div className="loading-wrapper" data-testid="loader-wrapper">
      <div className={"spinner spinner-" + size + " green bg-white"}></div>
    </div>
  )
}
